import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Page from 'src/layout/Page';
import './subscription-paid.css';

const SubscriptionPaid: React.FC = (): React.ReactElement => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleNavigate = () => {
		if (i18n.language !== 'en') {
			navigate('/תיאום');
		} else {
			navigate('/en/booking');
		}
  };

  return (
    <Page pageClass={'subscribe-page'}>
      <div className="separator" />
      <div className={'excited-message'}>
        {t('pages.successfullBooking.title')}
        <img src="/wp-content/themes/hello-theme-child-master/src/assets/img/lama.png" alt="lama" className={'excited-lama'} />
      </div>
      <button className="scroll-to-button" onClick={handleNavigate}>
        {t('pages.successfullBooking.bookButton')}
      </button>
    </Page>
  );
};

/*
<div className={'excited-message'}>
      מתרגשים ומצפים להיפגש בשיעור הבא שלכם בא׳!
      <img src={lama} alt="lama" className={'excited-lama'}/>
    </div>
    <button className="scroll-to-button" onClick={handleNavigate}>אני רוצה לבחור שיעור לשבוע הקרוב...</button>
  </Page>;

*/

export default SubscriptionPaid;
